document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
  const variantPicker = document.querySelector('variant-picker');
  if (!stickyBar || !variantPicker) return;

  const wrap = document.createElement('div');
  wrap.style.cssText = 'display:flex;gap:8px;align-items:center;margin:0 8px;flex-shrink:0;';

  variantPicker.querySelectorAll('fieldset').forEach(fs => {
    const legend = fs.querySelector('legend')?.textContent?.trim() || '';
    const inputs = [...fs.querySelectorAll('input[type="radio"]')];
    if (!inputs.length) return;

    const sel = document.createElement('select');
    sel.style.cssText = 'background:#142F47;color:#fff;border:1px solid #C9A961;border-radius:6px;padding:4px 8px;font-size:.75rem;cursor:pointer;height:28px;';
    sel.title = legend;

    inputs.forEach(input => {
      const opt = document.createElement('option');
      opt.value = input.value;
      opt.textContent = input.value;
      if (input.checked) opt.selected = true;
      sel.appendChild(opt);
    });

    sel.addEventListener('change', () => {
      const target = variantPicker.querySelector(`input[value="${sel.value}"]`);
      if (target) { target.checked = true; target.dispatchEvent(new Event('change', {bubbles:true})); }
    });

    wrap.appendChild(sel);
  });

  variantPicker.addEventListener('change', () => {
    variantPicker.querySelectorAll('input:checked').forEach((checked, i) => {
      if (wrap.children[i]) wrap.children[i].value = checked.value;
    });
  });

  const firstChild = stickyBar.firstElementChild;
  firstChild ? firstChild.insertAdjacentElement('afterend', wrap) : stickyBar.appendChild(wrap);
});